export default {
      id: "rotate-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#rotate-right-usage",
      toString: function () {
        return this.url;
      }
    }